import React from "react";
import { CloseIcon } from "../../../../../../components/icons"
import { useBookingEditText } from "../../../text";

const SubmitEditConfirmationModal = ({
    show,
    onClose,
    editFeeCalculation,
    calculatedEditBooking,
    userDeferredPaymentEligible,
    handleSubmitModification,
    isSubmittingModification,
    oldBooking,
    role = "individual",
    cn,
    getTypographyClass,
    chargeAmountNumber
}) => {
    const { t } = useBookingEditText();
    const getPriceDetails = () => {
        if (oldBooking.paymentStatus === "CHARGE_PENDING") {
            return;
        }

        if (oldBooking.totalPrice < (calculatedEditBooking.totalPrice + editFeeCalculation.totalFee + editFeeCalculation.meetAssistCancelFee)) {
            return (
                <section className="tw:w-full tw:flex tw:flex-col tw:gap-4">
                    <div
                        className={cn(
                            "tw:!p-4 tw:w-[calc(100%+32px)] tw:-mx-4 tw:sm:mx-0 tw:sm:w-full tw:border tw:border-[#e8e8e8] tw:sm:rounded-[5px] tw:bg-white tw:overflow-hidden tw:!mb-4",
                            getTypographyClass(14)
                        )}
                    >
                        <>
                            <div className={`tw:flex tw:w-full ${!userDeferredPaymentEligible ? "tw:border-b tw:border-[#e8e8e8] tw:!pb-4" : ""}`}>
                                {userDeferredPaymentEligible ? (
                                    <>
                                        <div className={`tw:!w-1/2 tw:flex tw:items-start`}>
                                            <div className="tw:w-full">
                                                <p className="tw:!text-[#282828] tw:!font-[700] tw:!text-[15px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.previousBookingPrice")}</p>
                                                <p className="tw:text-[#282828] tw:!font-[400] tw:text-[15px] tw:!mb-0">{oldBooking.totalPrice?.toLocaleString()}{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.jpy")}</p>
                                            </div>
                                        </div>
                                        <div className="tw:!w-1/2 tw:border-l tw:border-[#e8e8e8] tw:flex tw:flex-col tw:lg:flex-row">
                                            <div className="tw:w-full tw:pl-4">
                                                <p className="tw:!text-[#282828] tw:!font-[700] tw:!text-[15px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.newBookingPrice")}</p>
                                                <p className="tw:!text-[#3CAEA3] tw:!font-[700] tw:text-[15px] tw:!mb-0">{(calculatedEditBooking.totalPrice + editFeeCalculation.totalFee + editFeeCalculation.meetAssistCancelFee).toLocaleString()}{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.jpy")}</p>
                                                {
                                                    (editFeeCalculation.totalFee > 0 || editFeeCalculation.meetAssistCancelFee > 0) && (
                                                        <p className="tw:!text-[#7C7B7B] tw:!font-[400] tw:!text-[12px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.inclCancellationFee")}</p>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className={`tw:!w-1/3 tw:flex tw:items-start`}>
                                            <div className="tw:w-full">
                                                <p className="tw:!text-[#282828] tw:!font-[700] tw:!text-[15px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.chargedAmount")}</p>
                                                <p className="tw:text-[#282828] tw:!font-[400] tw:text-[15px] tw:!mb-0">{oldBooking.totalPrice?.toLocaleString()}{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.jpy")}</p>
                                            </div>
                                        </div>
                                        <div className="tw:!w-1/3 tw:border-l tw:border-[#e8e8e8] tw:flex tw:flex-col tw:lg:flex-row">
                                            <div className="tw:w-full tw:pl-4">
                                                <p className="tw:!text-[#282828] tw:!font-[700] tw:!text-[15px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.newBookingPrice")}</p>
                                                <p className="tw:text-[#282828] tw:!font-[400] tw:text-[15px] tw:!mb-0">{(calculatedEditBooking.totalPrice + editFeeCalculation.totalFee + editFeeCalculation.meetAssistCancelFee).toLocaleString()}{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.jpy")}</p>
                                                {
                                                    (editFeeCalculation.totalFee > 0 || editFeeCalculation.meetAssistCancelFee > 0) && (
                                                        <p className="tw:!text-[#7C7B7B] tw:!font-[400] tw:!text-[12px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.inclCancellationFee")}</p>
                                                    )
                                                }
                                            </div>
                                        </div>
                                        <div className="tw:!w-1/3 tw:border-l tw:border-[#e8e8e8] tw:flex tw:flex-col tw:lg:flex-row">
                                            <div className="tw:w-full tw:pl-4">
                                                <p className="tw:!text-[#282828] tw:!font-[700] tw:!text-[15px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.additionalFee")}</p>
                                                <p className="tw:!text-[#3CAEA3] tw:!font-[700] tw:text-[15px] tw:!mb-0">{((calculatedEditBooking.totalPrice + editFeeCalculation.totalFee + editFeeCalculation.meetAssistCancelFee) - oldBooking.totalPrice).toLocaleString()}{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.jpy")}</p>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>

                            {
                                !userDeferredPaymentEligible && (
                                    <div className="tw:flex tw:w-full tw:!pt-4">
                                        <div className="tw:!w-full tw:flex tw:items-center">
                                            <p className="tw:!text-[#7C7B7B] tw:!font-[400] tw:!text-[14px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.chargeInfo")}</p>
                                        </div>
                                    </div>
                                )
                            }
                        </>
                    </div>
                </section>
            );
        } else if (oldBooking.totalPrice > (calculatedEditBooking.totalPrice + editFeeCalculation.totalFee + editFeeCalculation.meetAssistCancelFee)) {
            return (
                <section className="tw:w-full tw:flex tw:flex-col tw:gap-4">
                    <div
                        className={cn(
                            "tw:!p-4 tw:w-[calc(100%+32px)] tw:-mx-4 tw:sm:mx-0 tw:sm:w-full tw:border tw:border-[#e8e8e8] tw:sm:rounded-[5px] tw:bg-white tw:overflow-hidden tw:!mb-4",
                            getTypographyClass(14)
                        )}
                    >
                        <>
                            <div className={`tw:flex tw:w-full ${editFeeCalculation.refundAmount > 0 ? "tw:border-b tw:border-[#e8e8e8] tw:!pb-4" : ""}`}>
                                <div className={`${userDeferredPaymentEligible ? 'tw:!w-full' : 'tw:!w-1/2'} tw:flex tw:items-center`}>
                                    {userDeferredPaymentEligible ? (
                                        <div className="tw:w-full">
                                            <p className="tw:!text-[#282828] tw:!font-[700] tw:!text-[15px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.updatedBookingFee")}</p>
                                            <p className="tw:text-[#282828] tw:!font-[400] tw:text-[15px] tw:!mb-0">{((editFeeCalculation.totalFee || 0) + (editFeeCalculation.meetAssistCancelFee || 0) + (calculatedEditBooking.totalPrice || 0))?.toLocaleString()}{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.jpy")}</p>
                                        </div>
                                    ) : (
                                        <div className="tw:w-full">
                                            <p className="tw:!mb-0 tw:!text-left tw:!leading-[1.2]"><span className="tw:!text-[#282828] tw:!font-[700] tw:!text-[14px]">{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.refundAmount")}</span> <span className="tw:!text-[#7C7B7B] tw:!font-[400] tw:!text-[13px]">{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.refundAmountNote")}</span></p>
                                            <p className="tw:text-[#282828] tw:!font-[400] tw:text-[15px] tw:!mb-0">{editFeeCalculation.refundAmount === 0 ? "-" : editFeeCalculation.refundAmount?.toLocaleString()}{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.jpy")}</p>
                                        </div>
                                    )}
                                </div>
                                {
                                    !userDeferredPaymentEligible && (
                                        <div className="tw:!w-1/2 tw:border-l tw:border-[#e8e8e8] tw:flex tw:flex-col tw:lg:flex-row">
                                            <div className="tw:w-full tw:pl-4">
                                                <p className="tw:!text-[#282828] tw:!font-[700] tw:!text-[15px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.cancellationFee")}</p>
                                                <p className="tw:text-[#282828] tw:!font-[400] tw:text-[15px] tw:!mb-0">{((editFeeCalculation.totalFee || 0) + (editFeeCalculation.meetAssistCancelFee || 0))?.toLocaleString()}{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.jpy")}</p>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>

                            {
                                editFeeCalculation.refundAmount > 0 && (
                                    <div className="tw:flex tw:w-full tw:!pt-4">
                                        <div className="tw:!w-full tw:flex tw:items-center">
                                            {
                                                userDeferredPaymentEligible ? (
                                                    <p className="tw:!text-[#7C7B7B] tw:!font-[400] tw:!text-[14px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.cancellationFeeInfo", { cancellationFeeTotal: ((editFeeCalculation.totalFee || 0) + (editFeeCalculation.meetAssistCancelFee || 0))?.toLocaleString() })}</p>
                                                ) : (
                                                    <p className="tw:!text-[#7C7B7B] tw:!font-[400] tw:!text-[14px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.refundInfo")}</p>
                                                )
                                            }
                                        </div>
                                    </div>
                                )
                            }
                        </>
                    </div>
                </section>
            )
        } else if (oldBooking.totalPrice === (calculatedEditBooking.totalPrice + editFeeCalculation.totalFee + editFeeCalculation.meetAssistCancelFee)) {
            return (
                <section className="tw:w-full tw:flex tw:flex-col tw:gap-4">
                    <div
                        className={cn(
                            "tw:!p-4 tw:w-[calc(100%+32px)] tw:-mx-4 tw:sm:mx-0 tw:sm:w-full tw:border tw:border-[#e8e8e8] tw:sm:rounded-[5px] tw:bg-white tw:overflow-hidden tw:!mb-4",
                            getTypographyClass(14)
                        )}
                    >
                        <>
                            <div className={`tw:flex tw:w-full`}>
                                {userDeferredPaymentEligible ? (
                                    <>
                                        <div className={`tw:!w-1/2 tw:flex tw:items-start`}>
                                            <div className="tw:w-full">
                                                <p className="tw:!text-[#282828] tw:!font-[700] tw:!text-[15px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.previousBookingPrice")}</p>
                                                <p className="tw:text-[#282828] tw:!font-[400] tw:text-[15px] tw:!mb-0">{oldBooking.totalPrice?.toLocaleString()}{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.jpy")}</p>
                                            </div>
                                        </div>
                                        <div className="tw:!w-1/2 tw:border-l tw:border-[#e8e8e8] tw:flex tw:flex-col tw:lg:flex-row">
                                            <div className="tw:w-full tw:pl-4">
                                                <p className="tw:!text-[#282828] tw:!font-[700] tw:!text-[15px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.newBookingPrice")}</p>
                                                <p className="tw:!text-[#3CAEA3] tw:!font-[700] tw:text-[15px] tw:!mb-0">{(calculatedEditBooking.totalPrice + editFeeCalculation.totalFee + editFeeCalculation.meetAssistCancelFee).toLocaleString()}{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.jpy")}</p>
                                                {
                                                    (editFeeCalculation.totalFee > 0 || editFeeCalculation.meetAssistCancelFee > 0) && (
                                                        <p className="tw:!text-[#7C7B7B] tw:!font-[400] tw:!text-[12px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.inclCancellationFee")}</p>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className={`tw:!w-1/2 tw:flex tw:items-start`}>
                                            <div className="tw:w-full">
                                                <p className="tw:!text-[#282828] tw:!font-[700] tw:!text-[15px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.chargedAmount")}</p>
                                                <p className="tw:text-[#282828] tw:!font-[400] tw:text-[15px] tw:!mb-0">{oldBooking.totalPrice?.toLocaleString()}{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.jpy")}</p>
                                            </div>
                                        </div>
                                        <div className="tw:!w-1/2 tw:border-l tw:border-[#e8e8e8] tw:flex tw:flex-col tw:lg:flex-row">
                                            <div className="tw:w-full tw:pl-4">
                                                <p className="tw:!text-[#282828] tw:!font-[700] tw:!text-[15px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.newBookingPrice")}</p>
                                                <p className="tw:text-[#282828] tw:!font-[400] tw:text-[15px] tw:!mb-0">{(calculatedEditBooking.totalPrice + editFeeCalculation.totalFee + editFeeCalculation.meetAssistCancelFee).toLocaleString()}{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.jpy")}</p>
                                                {
                                                    (editFeeCalculation.totalFee > 0 || editFeeCalculation.meetAssistCancelFee > 0) && (
                                                        <p className="tw:!text-[#7C7B7B] tw:!font-[400] tw:!text-[12px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{t("editBooking.BookingReviewPage.bookingEditConfirmationModal.inclCancellationFee")}</p>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </>
                    </div>
                </section>
            );
        }
    }

    const getEditBookingTnc = () => {
        if (oldBooking.paymentStatus === "CHARGE_PENDING") {
            return (
                <div className="tw:!rounded-[6px] tw:!bg-[#F6F6F6] tw:!p-4 tw:!mb-4">
                    <ul className={"tw:list-disc tw:!text-[#4e4e4e] tw:text-[16px] tw:font-hanken-grotesk tw:!mb-0"}>
                        <li className="tw:!text-[15px] tw:!font-[400] tw:!mb-1">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: t("editBooking.BookingReviewPage.bookingEditConfirmationModal.editBookingTnc.firstContent")
                                }}
                            />
                        </li>
                        {
                            userDeferredPaymentEligible ? (
                                <>
                                    <li className="tw:!text-[15px] tw:!font-[400] tw:!mb-1">
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: t("editBooking.BookingReviewPage.bookingEditConfirmationModal.editBookingTnc.content.unconfirmed.deferredPayment.one")
                                            }}
                                        />
                                    </li>
                                </>
                            ) : (
                                <>
                                    <li className="tw:!text-[15px] tw:!font-[400] tw:!mb-1">
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: t("editBooking.BookingReviewPage.bookingEditConfirmationModal.editBookingTnc.content.unconfirmed.advancePayment.one")
                                            }}
                                        />
                                    </li>
                                    <li className="tw:!text-[15px] tw:!font-[400]">
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: t("editBooking.BookingReviewPage.bookingEditConfirmationModal.editBookingTnc.content.unconfirmed.advancePayment.two")
                                            }}
                                        />
                                    </li>
                                </>
                            )
                        }
                    </ul>
                </div>
            )
        } else {
            return (
                <div className="tw:!rounded-[6px] tw:!bg-[#F6F6F6] tw:!p-4 tw:!mb-4">
                    <ul className={"tw:list-disc tw:!text-[#4e4e4e] tw:text-[16px] tw:font-hanken-grotesk tw:!mb-0"}>
                        <li className="tw:!text-[15px] tw:!font-[400] tw:!mb-1">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: t("editBooking.BookingReviewPage.bookingEditConfirmationModal.editBookingTnc.firstContent")
                                }}
                            />
                        </li>
                        {
                            userDeferredPaymentEligible ? (
                                <>
                                    <li className="tw:!text-[15px] tw:!font-[400] tw:!mb-1">
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: t("editBooking.BookingReviewPage.bookingEditConfirmationModal.editBookingTnc.content.confirmed.deferredPayment.one")
                                            }}
                                        />
                                    </li>
                                </>
                            ) : (
                                <>
                                    <li className="tw:!text-[15px] tw:!font-[400] tw:!mb-1">
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: t("editBooking.BookingReviewPage.bookingEditConfirmationModal.editBookingTnc.content.confirmed.advancePayment.one")
                                            }}
                                        />
                                    </li>
                                </>
                            )
                        }
                    </ul>
                </div>
            )
        }
    }

    const getConfirmationButtonText = () => {
        if (isSubmittingModification) {
            return t(
                "editBooking.BookingReviewPage.bookingEditConfirmationModal.updating"
            );
        }

        if (oldBooking.paymentStatus === "CHARGE_PENDING" || chargeAmountNumber === 0) {
            return "Update Booking Details";
        }

        return t(
            "editBooking.BookingReviewPage.bookingEditConfirmationModal.submitModificationRequest"
        );
    };

    return (
        <div className={`tw:fixed tw:inset-0 tw:z-[9999] tw:flex tw:items-center tw:justify-center ${show ? 'tw:block' : 'tw:hidden'}`}>
            <div
                aria-label="Close modal backdrop"
                className="tw:absolute tw:inset-0 tw:bg-[#00000099]"
                onClick={onClose}
            />
            <div className="tw:relative tw:z-[10000] tw:w-[calc(100%-24px)] tw:lg:w-[660px] tw:rounded-[8px] tw:bg-white tw:px-4 tw:py-5 tw:md:px-10 tw:md:py-8 tw:shadow-lg">
                <button
                    type="button"
                    onClick={onClose}
                    aria-label="Close"
                    className="tw:absolute tw:top-6 tw:right-6"
                >
                    <CloseIcon color="#7c7b7b" size={16} />
                </button>

                <div className="tw:!text-center tw:!mt-4 tw:!mb-6">
                    <p className="tw:!text-[#282828] tw:!mb-2 tw:!text-[18px] tw:!font-[600] tw:font-hanken-grotesk tw:max-w-full">
                        {t("editBooking.BookingReviewPage.bookingEditConfirmationModal.title")}
                    </p>
                    <p className="tw:!text-[#8D8D8D] tw:!mb-0 tw:!text-[15px] tw:!font-[400] tw:font-hanken-grotesk">
                        {t("editBooking.BookingReviewPage.bookingEditConfirmationModal.subtitle")}
                    </p>
                </div>

                <>
                    {
                        getPriceDetails()
                    }

                    {
                        getEditBookingTnc()
                    }
                </>

                <div className="tw:flex tw:flex-col tw:lg:flex-row tw:items-stretch tw:gap-2">
                    <button
                        type="button"
                        onClick={onClose}
                        disabled={isSubmittingModification}
                        className="tw:flex-1"
                    >
                        <div className="tw:!py-3 tw:w-full tw:md:flex-1 tw:rounded-[8px] tw:border tw:border-[#d0d0d0] tw:bg-white tw:text-[#282828] tw:text-[15px] tw:leading-[22px] tw:font-medium tw:font-hanken-grotesk tw:flex tw:items-center tw:justify-center">
                            {t("editBooking.BookingReviewPage.bookingEditConfirmationModal.back")}
                        </div>
                    </button>
                    <button
                        type="button"
                        onClick={handleSubmitModification}
                        disabled={isSubmittingModification}
                        className="tw:flex-1"
                    >
                        <div className="tw:!py-3 tw:w-full tw:md:flex-1 tw:rounded-[8px] tw:bg-[#d4b055] tw:text-white tw:text-[15px] tw:leading-[22px] tw:!font-[700] tw:font-hanken-grotesk tw:flex tw:items-center tw:justify-center">
                            {getConfirmationButtonText()}
                        </div>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SubmitEditConfirmationModal;
